import { INVESTMENT_PERFORMANCE_V2_REDUCER_KEY } from './investmentPerformanceV2Reducer';

export const getResourceStore = (state) => state[INVESTMENT_PERFORMANCE_V2_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const isLoading = (state) => getResourceStore(state).isLoading;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getInvestmentPerformance = (state) => getResourceStore(state).resourcesById;

